import { render } from "./topBtn.vue?vue&type=template&id=0e562a10"
import script from "./topBtn.vue?vue&type=script&lang=js"
export * from "./topBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__